import { useFiltersApi } from '@/hooks'

export const useNodesFiltersError = () => {
    const { useNodesQuery } = useFiltersApi()
    const nodesQuery = useNodesQuery()

    const isFiltersError = nodesQuery.isError

    return {
        isFiltersError,
    }
}
